import React, { Component } from 'react';
import { connect } from 'react-redux';

import IssuesPieWrapper from './IssuesPieWrapper';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';

import {
  companyRelationshipTypeIdSelector,
} from '../../../reducers/relationshipTypes';

const IssuesPieContainerSelector = immutableCreatorSelector(
  [
    companyRelationshipTypeIdSelector,
  ],
  (
    companyRelationshipTypeId,
  ) => {
    return {
      companyRelationshipTypeId,
    };
  },
);

@connect(IssuesPieContainerSelector)
class IssuesPieContainer extends Component {
  render() {
    const { companyRelationshipTypeId, projectId } = this.props;
    return (
      <IssuesPieWrapper
        companyRelationshipTypeId={companyRelationshipTypeId}
        projectId={projectId}
      />
    );
  }
}

export default IssuesPieContainer;



// WEBPACK FOOTER //
// ./src/views/Project/PieChart/IssuesPieContainer.js